import { createValidator } from "../../utils/validation";
import {
  PurchaserEddInfoSchema,
  SellerEddInfoSchema,
  PurchaserClientKnownDuration,
  PurchaseFundVerified,
  PurchaserWealthSourceOther,
  SellerWealthSourceOther,
  SellerClientKnownDuration,
  MortgageBankName,
} from "../validationRules/EDDValidationForm";

// Which half of the form applies. Kept identical to the render conditions in
// forms/EDD/edd.js: an unknown clientType shows BOTH halves, so both must be validated.
// Previously an unknown clientType rendered both but validated only the Purchaser schema,
// so every visible Seller question could be left blank and still pass Validate & Lock.
const isPurchaserSide = (clientType) =>
  !clientType || clientType === "Tenant" || clientType === "Purchaser";

const isSellerSide = (clientType) =>
  !clientType || clientType === "Landlord" || clientType === "Vendor";

export const useValidateEdd = () => {
  const validateEdd = (formData, clientType) => {
    let schema = {};

    // Merge, never assign. The base schema used to be assigned over the conditional rules
    // (`schema = {...PurchaserEddInfoSchema}`), which discarded them. The second set of
    // conditionals then keyed off relationshipTime / VerifiedSource / PropertyMortage —
    // field names that do not exist in formData — so PurchaserClientKnownDuration,
    // PurchaseFundVerifiedDetail and MortgageBankName were never required at all.
    if (isPurchaserSide(clientType)) {
      schema = { ...schema, ...PurchaserEddInfoSchema };

      if (formData.PurchaserwealthSource === "Other") {
        schema = { ...schema, ...PurchaserWealthSourceOther };
      }
      if (formData.PurchaserIsRelationshipNew === "No") {
        schema = { ...schema, ...PurchaserClientKnownDuration };
      }
      if (formData.PurchaserFundSourceVerifiedIndependently === "Yes") {
        schema = { ...schema, ...PurchaseFundVerified };
      }
    }

    if (isSellerSide(clientType)) {
      schema = { ...schema, ...SellerEddInfoSchema };

      if (formData.SellerWealthSource === "Other") {
        schema = { ...schema, ...SellerWealthSourceOther };
      }
      if (formData.SellerIsRelationshipNew === "No") {
        schema = { ...schema, ...SellerClientKnownDuration };
      }
      if (formData.MortgageOnProperty === "Yes") {
        schema = { ...schema, ...MortgageBankName };
      }
    }

    return createValidator(schema)(formData);
  };

  return { validateEdd };
};
